var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProsperFilledDropShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 66,
    height: 66,
    rx: 9.5,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66.4346,
    height: 66.4346,
    rx: 9.5,
    fill: "#D5E4FF",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4163 10C42.8631 10 51.3335 18.4187 51.3335 28.8067C51.3335 39.1946 42.8631 47.617 32.4163 47.617V35.1891C35.9591 35.1891 38.8311 32.3332 38.8311 28.8065C38.8311 25.2836 35.9591 22.4278 32.4163 22.4278V10Z",
    fill: "#205CC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4166 31.7432C33.9777 31.7432 35.2432 30.4777 35.2432 28.9166C35.2432 27.3554 33.9777 26.0898 32.4166 26.0898C30.8554 26.0898 29.5898 27.3554 29.5898 28.9166C29.5898 30.4777 30.8554 31.7432 32.4166 31.7432Z",
    fill: "#FF5B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1212 10H20V56.9994H27.1212V10Z",
    fill: "#205CC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsperFilledDropShadow);
export default __webpack_public_path__ + "static/media/prosper-filled-drop-shadow.eeeb19f465543681599290c8aed5af95.svg";
export { ForwardRef as ReactComponent };